import {Observable} from 'rxjs';
import {axiosInstance} from '@/api/axios.config.api';
import {map} from 'rxjs/operators';
import {ImagesModel} from '@/models/images.model';

export class ImagesApi {
  fetchImages(): Observable<ImagesModel> {
    return axiosInstance().get<ImagesModel>('settings/images')
      .pipe(map((response) => response.data))
  }
}
